<t4-header icon="glyphicon-stats"></t4-header>
<t4-container>
  <div class="row">
    <div class="col-xs-12 col-sm-6">
      <img #gmap style="height: 250px; float: left; margin-right: 10px;" />
      <div style="position: relative;">
        <h2>{{ location?.Name }} ({{ location?.Id}})</h2>
        <p>
          {{ location?.Address }}<br />
          {{ location?.ZipCode }} {{ location?.City }}<br /><br />
          {{ location?.Phone }}<br />
          <a href="mailto:{{ location?.Email }}">{{ location?.Email}}</a><br />

          <ng-container *ngIf="invoiceAddress">
            <h2>{{ 'turbo.Settings.MyStore.lblInvoiceAddress' | translate : 'Invoice address'}}</h2>
            <p>
              {{ invoiceAddress?.Name }}<br />
              {{ invoiceAddress?.Address }}<br />
              {{ invoiceAddress?.Zipcode }} {{ invoiceAddress?.City }}
              </p>
            </ng-container>

        <p style="font-size: 0.8em;">{{ location?.OpenHours }}</p>
        <div *ngIf="location?.Distance" style="position:absolute; top: 0; right: 0; font-weight: bold;">{{ location?.Distance | number : '0.0-0' }}km</div>
        <div>
          <br /><br />
          <br />
        </div>
      </div>

    </div>
    <div class="col-xs-12 col-sm-3">
      <h2>{{ 'turbo.Settings.MyStore.lblServicePartner' | translate : 'Service partner'}}</h2>
      <span style="display:  inline-block; margin-top: 10px;">
        {{serviceLocation?.Name}}
      </span>
      <br />
      <span style="display:  inline-block; margin-top: 10px;">
        {{serviceLocation?.Phone}}<br />
        <a href="mailto:{{serviceLocation?.Email}}">{{serviceLocation?.Email}}</a>
      </span>
      <br />
      <ng-container *ngIf="serviceGuy">
        <h2 style="margin-top:10px; margin-bottom:-10px;">{{ 'turbo.Settings.MyStore.lblServicePerson' | translate : 'Service person'}}</h2>
        <span>
          <br />
          {{serviceGuy?.Firstname}} {{serviceGuy?.Lastname}}<br />
          {{serviceGuy?.Phone}}<br />
          <a href="mailto:{{ location?.Email }}">{{ serviceGuy?.Email}}</a><br />
        </span>
      </ng-container>
    </div>
    <div class="col-xs-12 col-sm-3" style="text-align: center; line-height: 250px; vertical-align: middle;">
      <button mat-raised-button (click)="gotoSupport()" color="primary">Kontakta Brenderup</button>
    </div>
  </div>
</t4-container>
<t4-container title=" ">
  <mat-tab-group>
    <mat-tab *ngIf="false">
      <div class="row">
        <mat-form-field class="col-sm-12 col-md-3" style="width: auto;">
          <mat-select [(ngModel)]="selectedEmailTemplate">
            <mat-option *ngFor="let t of emailTemplates" [value]="t">{{ t.Key + "_Name" | translate : t.Name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="selectedEmailTemplate">{{ selectedEmailTemplate.Key + "_Description" | translate : selectedEmailTemplate.Description }}</div>
      </div>
      <div [froalaEditor]="options" *ngIf="selectedEmailTemplate" [(ngModel)]="selectedEmailTemplate.Content"></div>
    </mat-tab>
    <mat-tab label="{{ 'turbo.Settings.MyStore.tabOpenHours' | translate : 'Open hours'}}">
      <div class="col-xs-6">
        <div class="openhours" *ngIf="everyDay">
          <h2>{{ 'turbo.Settings.MyStore.lblEveryDay' | translate : 'Every day'}}</h2>
          <div>
            <div style="display: inline-block"><span>{{ everyDay.Opens | date : 'HH:mm' }}</span> - <span>{{ everyDay.Closes | date : 'HH:mm' }}</span></div>
            <button mat-icon-button (click)="clearTime(0)" style="color: red;"><mat-icon>delete</mat-icon></button>
          </div>
        </div>
        <div class="openhours">
          <h2>{{ 'turbo.Settings.MyStore.lblMondays' | translate : 'Mondays'}}</h2>
          <div *ngIf="monday">
            <div style="display: inline-block" *ngIf="!monday.Closed"><span >{{ monday.Opens | date : 'HH:mm' }}</span> - <span>{{ monday.Closes | date : 'HH:mm' }}</span></div>
            <div style="display: inline-block" *ngIf="monday.Closed"><span> {{ 'Turbo.Settings.MyStore.statusClosed' | translate : 'Closed' }}</span></div>
            <button mat-icon-button (click)="editTime(1, monday.Opens, monday.Closes, monday.Closed)"><mat-icon>create</mat-icon></button>
            <button mat-icon-button (click)="clearTime(1)" style="color: red;"><mat-icon>delete</mat-icon></button>
          </div>
          <button *ngIf="!monday" mat-icon-button (click)="editTime(1, null, null)" style="color: green;"><mat-icon>add_circle</mat-icon></button>
        </div>
        <div class="openhours">
          <h2>{{ 'turbo.Settings.MyStore.lblTuesdays' | translate : 'Tuesdays'}}</h2>
          <div *ngIf="tuesday">
            <div style="display: inline-block" *ngIf="!tuesday.Closed"><span>{{ tuesday.Opens | date : 'HH:mm' }}</span> - <span>{{ tuesday.Closes | date : 'HH:mm' }}</span></div>
            <div style="display: inline-block" *ngIf="tuesday.Closed"><span> {{ 'Turbo.Settings.MyStore.statusClosed' | translate : 'Closed' }}</span></div>
            <button mat-icon-button (click)="editTime(2, tuesday.Opens, tuesday.Closes, tuesday.Closed)"><mat-icon>create</mat-icon></button>
            <button mat-icon-button (click)="clearTime(2)" style="color: red;"><mat-icon>delete</mat-icon></button>
          </div>
          <button *ngIf="!tuesday" mat-icon-button (click)="editTime(2, null, null)" style="color: green;"><mat-icon>add_circle</mat-icon></button>
        </div>
        <div class="openhours">
          <h2>{{ 'turbo.Settings.MyStore.lblWednesdays' | translate : 'Wednesdays'}}</h2>
          <div *ngIf="wednesday">
            <div style="display: inline-block" *ngIf="!wednesday.Closed"><span>{{ wednesday.Opens | date : 'HH:mm' }}</span> - <span>{{ wednesday.Closes | date : 'HH:mm' }}</span></div>
            <div style="display: inline-block" *ngIf="wednesday.Closed"><span> {{ 'Turbo.Settings.MyStore.statusClosed' | translate : 'Closed' }}</span></div>
            <button mat-icon-button (click)="editTime(3, wednesday.Opens, wednesday.Closes, wednesday.Closed)"><mat-icon>create</mat-icon></button>
            <button mat-icon-button (click)="clearTime(3)" style="color: red;"><mat-icon>delete</mat-icon></button>
          </div>
          <button *ngIf="!wednesday" mat-icon-button (click)="editTime(3, null, null)" style="color: green;"><mat-icon>add_circle</mat-icon></button>
        </div>
        <div class="openhours">
          <h2>{{ 'turbo.Settings.MyStore.lblThursdays' | translate : 'Thursdays'}}</h2>
          <div *ngIf="thursday">
            <div style="display: inline-block" *ngIf="!thursday.Closed"><span>{{ thursday.Opens | date : 'HH:mm' }}</span> - <span>{{ thursday.Closes | date : 'HH:mm' }}</span></div>
            <div style="display: inline-block" *ngIf="thursday.Closed"><span> {{ 'Turbo.Settings.MyStore.statusClosed' | translate : 'Closed' }}</span></div>
            <button mat-icon-button (click)="editTime(4, thursday.Opens, thursday.Closes, thursday.Closed)"><mat-icon>create</mat-icon></button>
            <button mat-icon-button (click)="clearTime(4)" style="color: red;"><mat-icon>delete</mat-icon></button>
          </div>
          <button *ngIf="!thursday" mat-icon-button (click)="editTime(4, null, null)" style="color: green;"><mat-icon>add_circle</mat-icon></button>
        </div>
        <div class="openhours">
          <h2>{{ 'turbo.Settings.MyStore.lblFridays' | translate : 'Fridays'}}</h2>
          <div *ngIf="friday">
            <div style="display: inline-block" *ngIf="!friday.Closed"><span>{{ friday.Opens | date : 'HH:mm' }}</span> - <span>{{ friday.Closes | date : 'HH:mm' }}</span></div>
            <div style="display: inline-block" *ngIf="friday.Closed"><span> {{ 'Turbo.Settings.MyStore.statusClosed' | translate : 'Closed' }}</span></div>
            <button mat-icon-button (click)="editTime(5, friday.Opens, friday.Closes, friday.Closed)"><mat-icon>create</mat-icon></button>
            <button mat-icon-button (click)="clearTime(5)" style="color: red;"><mat-icon>delete</mat-icon></button>
          </div>
          <button *ngIf="!friday" mat-icon-button (click)="editTime(5, null, null)" style="color: green;"><mat-icon>add_circle</mat-icon></button>
        </div>
        <div class="openhours">
          <h2>{{ 'turbo.Settings.MyStore.lblSaturdays' | translate : 'Saturdays'}}</h2>
          <div *ngIf="saturday">
            <div style="display: inline-block" *ngIf="!saturday.Closed"><span>{{ saturday.Opens | date : 'HH:mm' }}</span> - <span>{{ saturday.Closes | date : 'HH:mm' }}</span></div>
            <div style="display: inline-block" *ngIf="saturday.Closed"><span> {{ 'Turbo.Settings.MyStore.statusClosed' | translate : 'Closed' }}</span></div>
            <button mat-icon-button (click)="editTime(6, saturday.Opens, saturday.Closes, saturday.Closed)"><mat-icon>create</mat-icon></button>
            <button mat-icon-button (click)="clearTime(6)" style="color: red;"><mat-icon>delete</mat-icon></button>
          </div>
          <button *ngIf="!saturday" mat-icon-button (click)="editTime(6, null, null)" style="color: green;"><mat-icon>add_circle</mat-icon></button>
        </div>
        <div class="openhours">
          <h2>{{ 'turbo.Settings.MyStore.lblSundays' | translate : 'Sundays'}}</h2>
          <div *ngIf="sunday">
            <div style="display: inline-block" *ngIf="!sunday.Closed"><span>{{ sunday.Opens | date : 'HH:mm' }}</span> - <span>{{ sunday.Closes | date : 'HH:mm' }}</span></div>
            <div style="display: inline-block" *ngIf="sunday.Closed"><span> {{ 'Turbo.Settings.MyStore.statusClosed' | translate : 'Closed' }}</span></div>
            <button mat-icon-button (click)="editTime(7, sunday.Opens, sunday.Closes, sunday.Closed)"><mat-icon>create</mat-icon></button>
            <button mat-icon-button (click)="clearTime(7)" style="color: red;"><mat-icon>delete</mat-icon></button>
          </div>
          <button *ngIf="!sunday" mat-icon-button (click)="editTime(7, null, null)" style="color: green;"><mat-icon>add_circle</mat-icon></button>
        </div>
      </div>
      <div class="col-xs-6">
        <h2>{{ 'turbo.Settings.MyStore.lblSpecial' | translate : 'Exceptions'}}</h2>
        <div>
          <div *ngFor="let i of specific">
            <span><b>{{ i.SpecificDate | date : 'yyyy-MM-dd' }}: </b></span>
            <ng-container *ngIf="!i.Closed">
              <span>{{ i.Opens | date : 'HH:mm' }}</span> - <span>{{ i.Closes | date : 'HH:mm' }}</span>
            </ng-container>
            <ng-container *ngIf="i.Closed">
              <span>{{ 'Turbo.Settings.MyStore.statusClosed' | translate : 'Closed' }}</span>
            </ng-container>
            <button mat-icon-button (click)="clearTime(-1, i.SpecificDate)" style="color: red;"><mat-icon>delete</mat-icon></button></div>
          <div *ngIf="!specific || specific.length <= 0">{{ 'turbo.Settings.MyStore.lblNoSpecial' | translate : 'No special open hours exists' }}</div>
        </div>
        <div style="margin-top: 15px;">
          <mat-form-field style="width: 150px">
            <mat-icon matPrefix>date_range</mat-icon>
            <input matInput [matDatepicker]="pickupPicker" placeholder="{{ 'turbo.Settings.MyStore.lblDate' | translate : 'Date'}}" [min]="today.toDate()" [(ngModel)]="specificDate">
            <mat-datepicker-toggle matSuffix [for]="pickupPicker"></mat-datepicker-toggle>
            <mat-datepicker #pickupPicker></mat-datepicker>
          </mat-form-field>
          <button mat-icon-button (click)="editSpecific(specificDate, null, null)" style="color: green;"><mat-icon>add_circle</mat-icon></button>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="{{ 'turbo.Settings.MyStore.tabPersonnel' | translate : 'Personnel'}}" *ngIf="mayEdit">
      <t4-LocationUsers></t4-LocationUsers>
    </mat-tab>

    <mat-tab label="{{ 'turbo.Settings.MyStore.lblServiceGuy2' | translate : 'Service Person'}}" *ngIf="mayEdit">
   
      <div class="row">
        <div class="col">
          <!-- Assign serviceGuy-->
          <h2 style="margin-bottom:30px; margin-top:25px;">{{ 'turbo.Settings.MyStore.lblServiceGuyChange' | translate : 'Service Person'}}</h2>
          <div style="margin-left:-10px;">
            <div class="col" style="margin-left:-10px;">
              <mat-form-field style="margin-top:-20px; margin-bottom:-10px;" appearance="outline">
                <input type="text"
                       matInput
                       [formControl]="serviceGuyControl"
                       [matAutocomplete]="serviceGuyAuto"
                       placeholder="{{ 'turbo.Settings.MyStore.lblServiceGuyChange' | translate : 'Service Person'}}" />

                <mat-spinner style="margin-right:15px" matSuffix *ngIf="loadingServiceGuys" mode="indeterminate" diameter="35"></mat-spinner>

                <mat-autocomplete #serviceGuyAuto="matAutocomplete" [displayWith]="formatServiceGuy">
                  <mat-option *ngFor="let r of filteredServiceGuys | async" [value]="r">
                    {{r.Identifier}} - {{r.Lastname}} {{r.Firstname}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          <div style="padding-top:25px;">
            <button name="changeServiceGuy" mat-raised-button (click)="assignServiceGuy()" color="primary">{{ 'turbo.Settings.MyStore.lblServiceGuyChangebutton' | translate : 'Change'}}</button>
          </div>
          <br />
          <!-- ServiceGuyInfo -->
          <div *ngIf="serviceGuy">
            <h2 style="margin-top:20px;">{{ 'turbo.Settings.MyStore.lblServiceGuy' | translate : 'Assigned Service Person'}}</h2>
            <p>
              {{serviceGuy?.Firstname}} {{serviceGuy?.Lastname}}<br />
              {{serviceGuy?.Phone}}<br />
              <a href="mailto:{{ location.Email }}">{{ serviceGuy.Email}}</a><br />
            </p>
          </div>

        </div>
      </div>

    </mat-tab>
    <mat-tab label="{{'T4.General.locationComponent.lblhistory' |translate : 'History' }}">
      <t4-entity-event entityId="{{Settings.clientSettings.RentalLocationId}}" entityType="4"></t4-entity-event>
    </mat-tab>
  </mat-tab-group>



</t4-container>



